import { useCallback, useEffect, useState } from "react";
import Button from "../../common/components/Button"
import Icon from "../../common/components/Icon"
import { useBroadcast } from "../../common/hooks/broadcastHook";
import { toLonLat } from "ol/proj";
import useClientConfig from "../../common/hooks/clientConfigHook";
import useNetwork from "../../common/hooks/networkHook";
import { altCoord, reverseGeoCode } from "../../utils/geoUtilities";
import { useOL } from "rlayers";
import { useCesiumVisible } from "./GeoMapContext";
import { useTranslation } from "react-i18next";
import { useMapHandlers } from "./MapHandlers";

export const GeoJobCreate = ({ style }) => {
    const { t } = useTranslation();
    const { map } = useOL();
    const cesiumVisible = useCesiumVisible();
    const broadcast = useBroadcast();
    const clientConfig = useClientConfig();
    const network = useNetwork();
    const [acquire, setAcquire] = useState(false);
    const { register } = useMapHandlers();

    useEffect(() => {
        if (cesiumVisible) {
            setAcquire(false);
        }
    }, [cesiumVisible]);

    const handleMapClick = useCallback(async (e) => {
        if (!acquire) {
            return false;
        }
        setAcquire(false);
        const coords = e.map.getCoordinateFromPixel(e.pixel);
        const [longitude, latitude] = toLonLat(coords);
        const data = { latitude, longitude };
        if (clientConfig.altcoordMode !== 'none') {
            let res = await altCoord(network, latitude, longitude);
            if (res?.addr) {
                data.w3w = res.addr;
            } 
        }
        if (clientConfig.enableGeocoding) {
            let pos = await reverseGeoCode(network, latitude, longitude);
            if (pos?.display_name) {
                data.location = pos.display_name;
            }
        }
        broadcast('createJob', data);
        return true;
    }, [acquire, broadcast, clientConfig.altcoordMode, clientConfig.enableGeocoding, network]);

    useEffect(() => register(handleMapClick, 100), [register, handleMapClick]);

    useEffect(() => {
        if (!map) {
            return undefined;
        }
        map.getTargetElement().style.cursor = acquire ? 'crosshair' : 'auto';
        return () => {
            map.getTargetElement().style.cursor = 'auto';
        }
    }, [acquire, map]);

    return !cesiumVisible && <div style={{ zIndex: 80, width: '38px', ...style }}>
        <Button id="mapJobCreate" className="w-100" variant="solid-primary" title={t('createJob')} onClick={() => setAcquire(acquire => !acquire)}><Icon intent="marker"></Icon></Button>
    </div>
}